import React, { useEffect, useState } from "react";
import Button from "../../Button";
import Icon from "../../Icon";

export const BackToTopButton = () => {
	const [showButton, setShowButton] = useState(false);
	const [prevOffset, setPrevOffset] = useState(0);
	const toggleScrollDirection = () => {
		const { scrollY } = window;
		const screenHeight = window.screen.height * 2;
		if (scrollY > prevOffset || scrollY < screenHeight) {
			setShowButton(false);
		} else if (scrollY < prevOffset && scrollY > screenHeight) {
			setShowButton(true);
		}
		setPrevOffset(scrollY);
	};
	useEffect(() => {
		window.addEventListener("scroll", toggleScrollDirection);
		return () => {
			window.removeEventListener("scroll", toggleScrollDirection);
		};
	});

	const scrollToTop = () => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	};
	return (
		<>
			{showButton && (
				<Button className="back-to-top-button" onClick={scrollToTop}>
					<Icon name="chevron-up" className="back-to-top-button--icon" />
					<span className="back-to-top-button--text">TOP</span>
				</Button>
			)}
		</>
	);
};
